import { type SalesLeadActivity, SalesLeadActivityType } from '@/models/salesLead'

function emailAddress(activity: SalesLeadActivity): string | null {
  if (activity.activityType === SalesLeadActivityType.EMAIL_INBOUND) {
    return activity.emailFrom ? `from ${activity.emailFrom}` : null
  }
  if (activity.activityType !== SalesLeadActivityType.EMAIL_OUTBOUND) return null
  // emailTo is the mailbox that ingested a channel message, which says nothing.
  if (activity.emailChannel) return `via ${activity.emailChannel}`
  return activity.emailTo ? `to ${activity.emailTo}` : null
}

function smsAddress(activity: SalesLeadActivity): string | null {
  if (activity.activityType === SalesLeadActivityType.SMS_OUTBOUND) {
    return activity.smsTo ? `to ${activity.smsTo}` : null
  }
  if (activity.activityType !== SalesLeadActivityType.SMS_INBOUND) return null
  if (activity.smsSenderDriver) {
    return `from driver ${activity.smsSenderDriver}${activity.smsFrom ? ` · ${activity.smsFrom}` : ''}`
  }
  return activity.smsFrom ? `from ${activity.smsFrom}` : null
}

function carrierName(activity: SalesLeadActivity): string | null {
  const isEligibility =
    activity.activityType === SalesLeadActivityType.CARRIER_ELIGIBLE ||
    activity.activityType === SalesLeadActivityType.CARRIER_INELIGIBLE
  return (isEligibility ? activity.carrier : activity.carrierCounterparty) || null
}

/** What follows the author on an activity's meta line: who it went to or came from, and the carrier. */
export function activityMetaParts(activity: SalesLeadActivity): string[] {
  return [emailAddress(activity), smsAddress(activity), carrierName(activity)].filter(
    (part): part is string => !!part
  )
}
